/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Levels_BodyInputs */

const en_for_whom_levels_body = /** @type {(inputs: For_Whom_Levels_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From your first session to competition level. Your strength score shows where you are today and how far the next step is.`)
};

const pl_for_whom_levels_body = /** @type {(inputs: For_Whom_Levels_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od pierwszego treningu do poziomu zawodniczego. Wynik siły pokazuje, gdzie jesteś dziś i ile dzieli Cię od kolejnego stopnia.`)
};

/**
* | output |
* | --- |
* | "From your first session to competition level. Your strength score shows where you are today and how far the next step is." |
*
* @param {For_Whom_Levels_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_levels_body = /** @type {((inputs?: For_Whom_Levels_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Levels_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_levels_body(inputs)
	return en_for_whom_levels_body(inputs)
});